<div class="login-container">
  <div class="wrapper">
    <!-- LEFT SIDE -->
    <section [class]="loginLeftCssClass" [innerHTML]="loginLeftBoxHtml" >
      
    </section>

    <!-- RIGHT SIDE -->
    <section class="login-panel">
      <div class="login-card">
        <div class="login-header">
          <h2>
            Sign In
          </h2>
          <p>
            Log in to continue your fitness journey
          </p>
        </div>
        <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
          {{ errorMessage }}
        </div>
        <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onLogin()">
          <div class="input-group">
            <span class="input-icon">
              <mat-icon fontSet="material-symbols-rounded">mail</mat-icon>
            </span>
            <input type="text"
                   placeholder="Username or Email"
                   formControlName="username"
                   [class.is-invalid]="username?.invalid && username?.touched" />
            <div *ngIf="username?.invalid && username?.touched" class="text-danger small hide">
              <div *ngIf="username?.errors?.['required']">Username is required</div>
              <div *ngIf="username?.errors?.['minlength']">Username must be at least 3 characters</div>
            </div>
          </div>
          <div class="input-group">
            <span class="input-icon">
              <mat-icon fontSet="material-symbols-rounded">lock</mat-icon>
            </span>
            <input [type]="showPassword ? 'text' : 'password'"
                   placeholder="Password"
                   formControlName="password"
                   [class.is-invalid]="password?.invalid && password?.touched" />
            <button type="button" class="eye-btn" (click)="togglePasswordVisibility()" tabindex="-1">
              <mat-icon fontSet="material-symbols-rounded">{{ showPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>
            <div *ngIf="password?.invalid && password?.touched" class="text-danger small hide">
              <div *ngIf="password?.errors?.['required']">Password is required</div>
              <div *ngIf="password?.errors?.['minlength']">Password must be at least 6 characters</div>
            </div>
          </div>
          <div class="options-row">
            <label class="remember">
              <input type="checkbox">
              <span>Remember me</span>
            </label>
            <a routerLink="/forgot-password" >
              Forgot password?
            </a>
          </div>
          <button class="login-btn" type="submit"
                  [disabled]="loginForm.invalid || isLoading">
            <span *ngIf="!isLoading">Log In</span>
            <span *ngIf="isLoading">
              <i class="fas fa-spinner fa-spin"></i> Logging in...
            </span>
          </button>
          <div class="divider">
            <span>or continue with</span>
          </div>
          <!-- SOCIAL -->
          <div class="social-login">
            <button>Google</button>
            <button>Apple</button>
            <button>Facebook</button>
          </div>
          <div class="signup-link">
            Don’t have an account?
            <a routerLink="/register" >Sign up</a>
          </div>
        </form>
      </div>
    </section>
  </div>

  <!-- FEATURES -->
  <section class="features" [innerHTML]="loginFooterHtml">
    
  </section>

  <!--<div class="screen">
    <div class="screen__content">
      <div class="login">
        <h2 class="login__title">FitnessBox</h2>

        <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
          {{ errorMessage }}
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
          <div class="login__field">
            <i class="login__icon fas fa-user"></i>
            <input type="text"
                   placeholder="Username or Email"
                   class="login__input"
                   formControlName="username"
                   [class.is-invalid]="username?.invalid && username?.touched" />
            <div *ngIf="username?.invalid && username?.touched" class="text-danger small">
              <div *ngIf="username?.errors?.['required']">Username is required</div>
              <div *ngIf="username?.errors?.['minlength']">Username must be at least 3 characters</div>
            </div>
          </div>

          <div class="login__field">
            <i class="login__icon fas fa-lock"></i>
            <input [type]="showPassword ? 'text' : 'password'"
                   placeholder="Password"
                   class="login__input"
                   formControlName="password"
                   [class.is-invalid]="password?.invalid && password?.touched" />
            <button type="button"
                    class="login__toggle-password"
                    (click)="togglePasswordVisibility()"
                    tabindex="-1">
              <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
            <div *ngIf="password?.invalid && password?.touched" class="text-danger small">
              <div *ngIf="password?.errors?.['required']">Password is required</div>
              <div *ngIf="password?.errors?.['minlength']">Password must be at least 6 characters</div>
            </div>
          </div>

          <button type="submit"
                  class="button login__submit"
                  [disabled]="loginForm.invalid || isLoading">
            <span *ngIf="!isLoading">Log In</span>
            <span *ngIf="isLoading">
              <i class="fas fa-spinner fa-spin"></i> Logging in...
            </span>
          </button>
        </form>

        <div class="login__footer">
          <p class="login__text">Don't have an account? <a href="/register">Register here</a></p>
          <p class="login__text"><a href="/forgot-password">Forgot password?</a></p>
        </div>
      </div>
    </div>
    <div class="screen__background">
      <span class="screen__background__shape screen__background__shape4"></span>
      <span class="screen__background__shape screen__background__shape3"></span>
      <span class="screen__background__shape screen__background__shape2"></span>
      <span class="screen__background__shape screen__background__shape1"></span>
    </div>
  </div>-->
</div>
